import { Image } from '@curology/ui-components-web/react/Image';
import React from 'react';

import { type ModalMeta } from '@/types/productSelectionAndCheckout/types';

export const ModalImage = ({ modal }: { modal: ModalMeta }) => (
  <Image alt={modal.image.alt} aspectRatio="3:2" src={modal.image.url} />
);
